module.exports = {
	"id": "VI",
	"name": "Virgin Islands (US)",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011846,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005923,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.005923,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.011846,
			"35": 0.011846,
			"36": 0.011846,
			"37": 0.005923,
			"38": 0.017769,
			"39": 0.047384,
			"40": 0.005923,
			"41": 0.023692,
			"42": 0.035538,
			"43": 0.047384,
			"44": 0.029615,
			"45": 0.011846,
			"46": 0.011846,
			"47": 0.065153,
			"48": 0.029615,
			"49": 1.101678,
			"50": 0.029615,
			"51": 0.213228,
			"52": 0.764067,
			"53": 19.717667,
			"54": 5.472852,
			"55": 0.136229,
			"56": 0.017769,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.023692,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.005923,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.011846,
			"22": null,
			"23": 0.005923,
			"24": 0.005923,
			"25": null,
			"26": 0.005923,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.011846,
			"32": 0.053307,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.011846,
			"38": 0.011846,
			"39": null,
			"40": 0.023692,
			"41": 0.005923,
			"42": 0.017769,
			"43": 0.106614,
			"44": 0.011846,
			"45": 0.17769,
			"46": 0.035538,
			"47": 0.35538,
			"48": 0.319842,
			"49": 6.402763,
			"50": 0.112537,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.017769
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.017769,
			"29": 0.017769,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.011846,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.011846,
			"38": null,
			"39": null,
			"40": 0.065153,
			"41": 0.005923,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011846
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.011846,
			"6": 0.005923,
			"7": 0.053307,
			"8": 0.248766,
			"9": 0.343534,
			"10": 1.842053,
			"3.1": null,
			"3.2": 0.023692,
			"5.1": 0.219151,
			"6.1": 0.112537,
			"7.1": 0.047384,
			"9.1": 1.83613
		},
		"ios_saf": {
			"8": 0,
			"10": 13.7734774471,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.371179279559,
			"8.1-8.4": 0.685737991049,
			"9.0-9.2": 0.32714105995,
			"9.3": 4.99099822231
		},
		"android": {
			"3": 0,
			"4": 0.0199846744186,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00249808430233,
			"4.1": 0.0720875755814,
			"4.2-4.3": 0.180218938953,
			"4.4": 0.413254517442,
			"4.4.3-4.4.4": 0.416823209302
		},
		"ie": {
			"6": null,
			"7": 0.005923,
			"8": 0.213228,
			"9": 0.373149,
			"10": 0.165844,
			"11": 9.233957,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0061855355016,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0001718204306
		},
		"edge": {
			"12": 0.621915,
			"13": 1.255676,
			"14": 4.513326
		},
		"ie_mob": {
			"10": 0.0731563098592,
			"11": 0.297850690141
		},
		"bb": {
			"7": 0.008154,
			"10": null
		},
		"samsung": {
			"0": 4.904631
		},
		"and_uc": {
			"0": 0.093771
		},
		"op_mini": {
			"0": 0.0833366440678
		},
		"and_chr": {
			"0": 15.164623
		},
		"and_ff": {
			"0": 0.024462
		}
	},
	"total": 98.758697
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VI.json
 ** module id = 679
 ** module chunks = 0
 **/